import { ForumError } from '../api/forumErrors';
import { forumId } from './forumMappers';

const invalid = field => { throw new ForumError('invalid_input', 'Revisa los filtros de la consulta.', 400, { [field]: 'Valor no válido.' }); };
function positive(value, field, fallback) {
  if (value === undefined) return fallback;
  if (!forumId(value) || !Number.isSafeInteger(Number(value))) return invalid(field);
  return Number(value);
}
function boolean(value, field, fallback) {
  if (value === undefined) return fallback;
  if ([true, 1, '1', 'true'].includes(value)) return true;
  if ([false, 0, '0', 'false'].includes(value)) return false;
  return invalid(field);
}
function section(value) {
  if (value === undefined || value === null || value === '') return undefined;
  return forumId(value) || invalid('section_id');
}
export function topicsQuery(input = {}) {
  const view = input.view === undefined ? 'recent' : input.view;
  if (!['recent', 'section', 'values'].includes(view)) return invalid('view');
  const sectionId = section(input.section_id);
  if (view === 'section' && !sectionId) return invalid('section_id');
  return { view, ...(sectionId ? { section_id: sectionId } : {}), page: positive(input.page, 'page', 1), limit: 20 };
}
export function threadTarget(input = {}) {
  if (input.comment_id !== undefined) return { comment_id: forumId(input.comment_id) || invalid('comment_id') };
  if (input.position !== undefined) {
    if (!['last', 'unread'].includes(input.position)) return invalid('position');
    return { position: input.position };
  }
  return { page: positive(input.page, 'page', 1) };
}
export function activityQuery(input = {}) {
  const tab = input.tab === undefined ? 'threads' : input.tab;
  if (!['threads', 'comments', 'favorites', 'notifications'].includes(tab)) return invalid('tab');
  return { tab, page: positive(input.page, 'page', 1), limit: 20 };
}
export function pendingQuery(input = {}) {
  const type = input.type === undefined ? 'all' : input.type;
  if (!['all', 'topic', 'comment'].includes(type)) return invalid('type');
  return { type, page: positive(input.page, 'page', 1), limit: 20 };
}
export function searchQuery(input = {}) {
  const q = input.q === undefined ? '' : input.q;
  if (typeof q !== 'string' || Array.from(q).length > 200) return invalid('q');
  const exact = boolean(input.exact, 'exact', false);
  const tokens = exact ? [q.trim()].filter(Boolean) : [...new Set((q.match(/"([^"]+)"|(\S+)/g) || []).map(token => token.replace(/^["\s]+|["\s]+$/g, '')).filter(Boolean))];
  if (tokens.length > 20) return invalid('q');
  const topics = boolean(input.topics, 'topics', true), comments = boolean(input.comments, 'comments', true);
  if (!topics && !comments) return invalid('type');
  const sectionId = section(input.section_id);
  return { q: q.trim(), exact, topics, comments, ...(sectionId ? { section_id: sectionId } : {}), page: positive(input.page, 'page', 1), limit: 20 };
}

// The visible form must decode the same contract as the request, including
// shared links using 0/1 rather than literal true/false.
export function searchFormState(input = {}) {
  const query = searchQuery(input);
  return { searchText: query.q, searchSection: query.section_id || '', searchExact: query.exact,
    searchType: !query.topics ? 'comments' : !query.comments ? 'topics' : 'all' };
}

// Inputs are normalized before keying, so URL 'false' and boolean false agree.
export function queryKey(resource, params = {}) {
  return JSON.stringify([resource, Object.keys(params).sort().map(key => [key, params[key]])]);
}
